
import { Button } from "@/components/ui/button";
import { Form, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { SignatureBox } from "./SignatureBox";
import { AddressFields } from "./form-sections/AddressFields";
import { ContactFields } from "./form-sections/ContactFields";
import { PersonalFields } from "./form-sections/PersonalFields";
import { ApplicationDateField } from "./form-sections/ApplicationDateField";
import { MembershipTypeField } from "./form-sections/MembershipTypeField";
import { PotatoAreaFields } from "./form-sections/PotatoAreaFields";
import { TermsAcceptance } from "./form-sections/TermsAcceptance";
import { useMembershipForm } from "./hooks/useMembershipForm";
import { AlertCircle, CheckCircle2 } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Turnstile } from "@/components/ui/turnstile";

export const MembershipForm = () => {
  const { form, onSubmit, isSubmitting, emailSendingIssue, submissionError, onCaptchaVerify, onCaptchaExpire, onCaptchaWidgetId } = useMembershipForm();

  return (
    <Form {...form}>
      <form id="membership-form" onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        {submissionError && (
          <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Error</AlertTitle>
            <AlertDescription>{submissionError}</AlertDescription>
          </Alert>
        )}

        {emailSendingIssue && (
          <Alert>
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Application Submitted</AlertTitle>
            <AlertDescription>
              Your application was submitted successfully, but there may have been an issue sending the confirmation email.
            </AlertDescription>
          </Alert>
        )}

        <ApplicationDateField form={form} />
        <PersonalFields form={form} />
        <AddressFields form={form} fieldPrefix="address" title="Address*" />
        <AddressFields form={form} fieldPrefix="businessAddress" title="Business Address" />
        <ContactFields form={form} />
        <MembershipTypeField form={form} />
        <PotatoAreaFields form={form} />
        <TermsAcceptance form={form} />

        <div className="space-y-4">
          <h3 className="font-semibold">Signature*</h3>
          <FormField
            control={form.control}
            name="signature"
            render={({ field }) => (
              <FormItem>
                <SignatureBox onChange={field.onChange} />
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <FormField
          control={form.control}
          name="captchaToken"
          render={() => (
            <FormItem>
              <h3 className="font-semibold mb-2">Verification*</h3>
              <Turnstile 
                onVerify={onCaptchaVerify}
                onExpire={onCaptchaExpire}
                onWidgetId={onCaptchaWidgetId}
              />
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="text-sm text-gray-600 mb-6">
          If you have any questions relating to any aspect of the membership application, 
          please contact Jim Cargill on 07767612230 or email{" "}
          <a href="mailto:info@seedpotatoorganisation.com" className="text-primary hover:underline">
            info@seedpotatoorganisation.com
          </a>
        </div>

        <div className="flex gap-4">
          <Button 
            type="submit" 
            className="w-full" 
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit Application"}
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={() => form.reset()}
            className="w-full"
            disabled={isSubmitting}
          >
            Clear
          </Button>
        </div>
      </form>
    </Form>
  );
};
